<template>
  <div v-if="items.length">
    <Title>Mais lidas</Title>
    <div>
      <template v-for="({ to, title, date }, i) in items">
        <v-card
          v-ripple
          :key="i + 'a'"
          :to="to"
          class="py-4 most-read-item"
          flat
          tile
        >
          <div
            class="
              font-weight-bold
              text-body-2
              mb-1
              grey--text
              text--darken-4
              most-read-item-title
            "
          >
            {{ title }}
          </div>
          <div class="text-body-2 text-capitalize text--secondary">
            {{ date | formatDate }}
          </div>
        </v-card>
        <v-divider :key="i + 'b'"></v-divider>
      </template>
    </div>
  </div>
</template>

<script>
import Title from "@/components/widgets/Title.vue";
import { formatToURL } from "@/components/utils";
import { mostReadCount } from "@/config.js";

export default {
  data: () => ({
    items: [],
  }),
  filters: {
    formatDate(v) {
      return new Date(v)
        .toLocaleString("pt-BR", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
        .replace(/\sde\s/g, " ");
    },
  },
  beforeCreate() {
    this.$rest("articles")
      .get({
        params: {
          mostRead: 1,
          itemsPerPage: mostReadCount,
        },
      })
      .then((data) => {
        this.items = data.map(({ id, date, title, category }) => ({
          title,
          to: `/noticias/${formatToURL(category.title)}/${formatToURL(
            `${title}-${id}`
          )}`,
          date,
        }));
      });
  },
  components: {
    Title,
  },
};
</script>

<style scoped>
.most-read-item-title {
  transition: all 0.1s linear;
}
.most-read-item:hover .most-read-item-title {
  color: var(--v-primary-darken2) !important;
}
</style>
